import { defineStyle } from "@chakra-ui/styled-system";

const baseStyleRoot = defineStyle((props) => {
  const { orientation } = props;
  return {
    display: orientation === "vertical" ? "flex" : "block"
  };
});

const baseStyleTab = defineStyle((props) => {
  const { isFitted } = props;

  return {
    flex: isFitted ? 1 : undefined,
    transitionProperty: "common",
    transitionDuration: "normal",

    _focusVisible: {
      zIndex: 1,
      boxShadow: "outline"
    }
    // _disabled: {
    //   cursor: "not-allowed",
    //   opacity: 0.4
    // }
  };
});

const baseStyleTablist = defineStyle((props) => {
  const { align = "start", orientation } = props;

  const alignments = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };

  return {
    justifyContent: alignments[align],
    flexDirection: orientation === "vertical" ? "column" : "row"
  };
});

const baseStyleTabpanel = defineStyle({
  p: 4
});

const baseStyle = (props) => ({
  root: baseStyleRoot(props),
  tab: baseStyleTab(props),
  tablist: baseStyleTablist(props),
  tabpanel: baseStyleTabpanel
});

const sizes = {
  md: {
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  }
};

const variantSoftRounded = (props) => {
  const { colorMode } = props || {};
  const bg = colorMode === "dark" ? "rgba(255, 255, 255, 0.08)" : "surface";
  return {
    tab: {
      borderRadius: "8px",
      fontWeight: "semibold",
      color: "mediumEmphasis",
      _selected: {
        color: "primary",
        bg
      }
    }
  };
};

const variants = {
  "soft-rounded": variantSoftRounded
};

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: "md",
    variant: "soft-rounded"
  }
};
